var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranchiseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.37 12.1003V18.0903C21.37 20.8503 19.13 23.0903 16.37 23.0903H7.63C4.87 23.0903 2.63 20.8503 2.63 18.0903V12.1703C3.39 12.9903 4.47 13.4603 5.64 13.4603C6.9 13.4603 8.11 12.8303 8.87 11.8203C9.55 12.8303 10.71 13.4603 12 13.4603C13.28 13.4603 14.42 12.8603 15.11 11.8603C15.88 12.8503 17.07 13.4603 18.31 13.4603C19.52 13.4603 20.62 12.9703 21.37 12.1003Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.99 1.96094H8.98997L8.24997 9.32094C8.18997 10.0009 8.28997 10.6409 8.53997 11.2209C9.11997 12.5809 10.48 13.4609 12 13.4609C13.54 13.4609 14.87 12.6009 15.47 11.2309C15.65 10.8009 15.76 10.3009 15.77 9.79094V9.60094L14.99 1.96094Z",
    fill: "#007AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.36 8.98094L22.07 6.21094C21.65 3.19094 20.28 1.96094 17.35 1.96094H13.51L14.25 9.46094C14.26 9.56094 14.27 9.67094 14.27 9.86094C14.33 10.3809 14.49 10.8609 14.73 11.2909C15.45 12.6109 16.85 13.4609 18.31 13.4609C19.64 13.4609 20.84 12.8709 21.59 11.8309C22.19 11.0309 22.46 10.0209 22.36 8.98094Z",
    fill: "#007AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.59002 1.96094C3.65002 1.96094 2.29002 3.19094 1.86002 6.24094L1.59002 8.99094C1.49002 10.0609 1.78002 11.1009 2.41002 11.9109C3.17002 12.9009 4.34002 13.4609 5.64002 13.4609C7.10002 13.4609 8.50002 12.6109 9.21002 11.3109C9.47002 10.8609 9.64002 10.3409 9.69002 9.80094L10.47 1.97094H6.59002V1.96094Z",
    fill: "#007AFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 17.3712C10.08 17.5012 9.12 18.5812 9.12 19.8612V23.0912H14.87V20.2112C14.88 18.1212 13.65 17.1312 11.35 17.3712Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranchiseActive);
export default __webpack_public_path__ + "static/media/franchiseActive.8dd62d2233e8ab9a1310fbe158159fc1.svg";
export { ForwardRef as ReactComponent };